import React from 'react';
import { brands } from '../../data/strategy';
type BrandLegendProps = {
  /** Render as the coloured bar strip from the source chart, or as dot keys. */
  variant?: 'bar' | 'dots';
  className?: string;
};
export function BrandLegend({
  variant = 'dots',
  className = ''
}: BrandLegendProps) {
  if (variant === 'bar') {
    return <ul className={`flex w-full overflow-hidden rounded-[2px] ${className}`} aria-label="Brand options compared" data-id="element-4" data-mp="8q9i2yioifo0">
        {brands.map(brand => <li key={brand.key} className="flex-1 px-[1%] py-[1vh] text-center text-paper" style={{
        background: brand.color
      }} data-id="element-5" data-mp="igkqoydb5d18">
            <span className="block text-[clamp(8px,0.95vw,15px)] font-bold uppercase tracking-[0.05em]" data-id="element-6" data-mp="rika1xbsot7c">
              {brand.name}
            </span>
            <span className="block text-[clamp(7px,0.8vw,13px)] font-medium text-paper/85" data-id="element-7" data-mp="2y90ho069sv87">
              {brand.form}
            </span>
          </li>)}
      </ul>;
  }
  return <ul className={`flex flex-wrap items-center gap-x-[2.2vw] gap-y-[1vh] ${className}`} aria-label="Brand options compared" data-id="element-8" data-mp="fjzafzlgrw3u">
      {brands.map(brand => <li key={brand.key} className="flex items-center gap-[0.6vw]" data-id="element-9" data-mp="pfkfy7pqreic">
          <span aria-hidden="true" className="rounded-full" style={{
        background: brand.color,
        width: 'clamp(7px, 0.85vw, 14px)',
        height: 'clamp(7px, 0.85vw, 14px)'
      }} data-id="element-10" data-mp="u727k55vk2qn" />
          <span className="text-[clamp(8px,0.9vw,14px)] font-semibold uppercase tracking-[0.06em] text-ink-soft" data-id="element-11" data-mp="13a3bbz79phr5">
            {brand.name}
          </span>
          <span className="text-[clamp(8px,0.9vw,14px)] text-ink-mute" data-id="element-12" data-mp="1d54zostpyfso">
            {brand.form}
          </span>
        </li>)}
    </ul>;
}